import Flickity from 'flickity';

export default class WhatsNew {
  constructor() {
    const $els = document.querySelectorAll('.js-whats-new');
    $els.forEach($el => new Carousel($el));
  }
}

class Carousel {
  constructor($el) {
    this.$el = $el;
    this.$carousel = this.$el.querySelector('.js-whats-new-carousel');
    this.flickity = new Flickity(this.$carousel, {
      imagesLoaded: true,
      prevNextButtons: false,
      pageDots: true,
      contain: 'true',
      cellAlign: 'left',
      groupCells: false
    });
  }
}
